// Auto-focusing SlimSelect's search input is desirable with a physical keyboard
// (type immediately after opening) but harmful on touch devices, where it pops
// the on-screen keyboard over the option list.
export function focusSearchOnOpen() {
  return window.matchMedia("(hover: hover) and (pointer: fine)").matches
}

// The settings every SlimSelect in the app shares, merged under the caller's own. `modal: "off"`
// keeps a dropdown on phones too — slim-select 4 otherwise opens a full-screen modal there.
export function slimSelectSettings(settings) {
  return { modal: "off", focusSearch: focusSearchOnOpen(), ...settings }
}
